import { PayloadAction } from '@reduxjs/toolkit';
import { assert_type_set } from '@shared/asserts/utils_asserts';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

interface Payload {
  value: Set<string>;
  key: keyof STATE__ui;
}

export const LOCAL__ui_put_set_of_strings = (payload: Payload): PayloadAction<Payload> => ({
  type: ENUM__redux_action.UI_PUT_SET_OF_STRINGS,
  payload,
});

export function INIT_LOCAL__ui_put_set_of_strings(state: STATE__ui, action: PayloadAction<Payload>) {
  let { key, value } = action.payload;

  let value_old = state[key];

  assert_type_set<string>(value_old);
  assert_type_set<string>(value);

  (state as any)[key] = new Set(value);
}
